import { useEffect } from 'react'
import queryString from 'query-string'

export const useQueryParams = (props) => {
  const { history, search: searchState, searchAll = () => {} } = props
  const { location: { search: locationSearch = '' } = {} } = history

  useEffect(() => {
    if (locationSearch.length) {
      changeQueryString()
    }
  }, [locationSearch.length])

  useEffect(() => {
    const { category, sort, page, ...rest } = getQueryParams()
    if (locationSearch.length) {
      searchAll({
        ...searchState,
        category,
        sort,
        filters: {
          ...searchState.filters,
          ...rest,
        },
        pagination: {
          ...searchState.pagination,
          page: page || 1,
        }
      })
    }
  }, [])

  const getQueryParams = (data = {}) => {
    const { category, sort, page, ...rest } = queryString.parse(locationSearch)
    return {
      category,
      sort,
      page,
      ...rest,
      ...data,
    }
  }

  const changeQueryString = (data = {}) => {
    history.replace({ search: queryString.stringify(getQueryParams(data)) })
  }

  return {
    getQueryParams,
    changeQueryString,
  }
}